export default __webpack_public_path__ + "static/media/LAS0190.34I-39639_-23669_0.df38cb2a.jpg";